module.exports = __webpack_public_path__ + "media/images/contest-label-right@3x-c7abbf6d9d1ebc51a42257d0ae2736d4.png";